module.exports = __webpack_public_path__ + "static/media/ac-min.ab78f2ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/ac-min.svg
// module id = 690
// module chunks = 0